import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        field: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'course.Add training field' | translate }}</h1>
        </div>
        <courses-fields-form form="vm.form" field="vm.field"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.field, model => model.$save({ expand: 'classifierI18ns' }));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/fields/add/index.js